import { AutogenModelEdiBilling, AutogenRowEdiBilling } from "./autogen/AutogenModelEdiBilling";

export class ModelEdiBilling extends AutogenModelEdiBilling<RowEdiBilling> {
	constructor() {
		super(RowEdiBilling);
	}
}

export class RowEdiBilling extends AutogenRowEdiBilling {
}